export default "__VITE_PUBLIC_ASSET__bfe84936__"